import React from "react";
import { Tag } from "antd";

/**
 * Coloured pill for a report / violation / appeal status.
 * Falls back to a neutral grey tag for unknown values.
 */
const COLORS = {
  // report status
  pending: "gold",
  reviewed: "blue",
  actioned: "green",
  dismissed: "default",
  // violation status
  active: "red",
  appealed: "purple",
  revoked: "green",
  expired: "default",
  // appeal status
  approved: "green",
  rejected: "volcano",
};

const LABELS = {
  pending: "PENDING",
  reviewed: "REVIEWED",
  actioned: "ACTIONED",
  dismissed: "DISMISSED",
  active: "ACTIVE",
  appealed: "APPEALED",
  revoked: "REVOKED",
  expired: "EXPIRED",
  approved: "APPROVED",
  rejected: "REJECTED",
};

const StatusPill = ({ status }) => {
  if (!status) return <Tag>—</Tag>;
  const key = String(status).toLowerCase();
  return <Tag color={COLORS[key] || "default"}>{LABELS[key] || key.toUpperCase()}</Tag>;
};

export default StatusPill;
